import './App.css';
import routes from './routes'
import cookie from 'js-cookie'
import {
    BrowserRouter as Router,
    Routes,
    Route
} from "react-router-dom";
import PrivateRoute from './routes/privateRouter';
import Welcome from './views/Welcome/Welcome';
import OTP from './views/Otp/Otp'
import 'bootstrap/dist/css/bootstrap.min.css';
import PersetujuanPage from './views/Persetujuan/PersetujuanPage';
function App() {
    let token = JSON.parse(localStorage.getItem("TOKEN"));
    return (
        <Router>
            <Routes>
                <Route exact path="/" element={<Welcome />} />
                <Route path="/:id" element={<Welcome />} />
                <Route path="/otp" element={<OTP />} />
                <Route path="/ps" element={<PersetujuanPage />} />
                {routes.map(({ path, elements }, id, index) => {
                    {
                        // if (cookie.get('accessToken') == "") {
                        // // if (token == undefined || token == null || token == "") {
                        //     return (
                        //         <>
                        //             <Route path="/:id" key={index} element={<Welcome />} />
                        //             <Route path="/otp" key={index} element={<OTP />} />
                        //         </>
                        //     )
                        // } else {
                        return (
                            <Route path={path} key={index} element={<PrivateRoute>{elements}</PrivateRoute>} />
                        )
                        // }
                    }
                })}
            </Routes>
        </Router>
    );
}

export default App;